import React from 'react';
import { Link } from 'react-router-dom';
import { DownloadIcon, MailIcon } from 'lucide-react';
const contactLinkClass = 'inline-flex items-center gap-1.5 whitespace-nowrap rounded text-muted underline-offset-4 transition-colors duration-150 hover:text-black hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-link';
type SiteHeaderProps = {
  /** Render as the page header (default) or as the repeated site footer. */
  as?: 'header' | 'footer';
};
export function SiteHeader({
  as = 'header'
}: SiteHeaderProps) {
  const Tag = as;
  const isFooter = as === 'footer';
  return <Tag className={`flex flex-col gap-3 md:flex-row md:items-center md:justify-between ${isFooter ? 'border-t border-black/10 pt-8' : ''}`} data-id="element-107" data-mp="14ubzvggk2y86">
      <Link to="/" className="flex w-fit items-center gap-x-2 rounded text-[clamp(13px,4vw,16px)] leading-6 min-[700px]:gap-x-[14px] min-[700px]:text-base focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-link" data-id="element-108" data-mp="2gaaedzui6cgs">
        <span className="whitespace-nowrap font-bold" data-id="element-109" data-mp="2ei3s0xatdf4c">MICHAEL MEIKSON</span>
        <span className="whitespace-nowrap text-muted" data-id="element-110" data-mp="2ji9g63hvkjho">Senior Product Designer</span>
      </Link>
      <nav className="flex items-center gap-6 text-[clamp(13px,4vw,16px)] leading-6 min-[700px]:gap-8 min-[700px]:text-base" aria-label={isFooter ? 'Footer contact' : 'Contact'} data-id="element-111" data-mp="2ogt3o8c4a3c5">
        <a href="https://cdn.magicpatterns.com/uploads/pwegPEgunv1kfUYB7UCBEg/Michael_Meikson_Resume.pdf" download="Michael_Meikson_Resume.pdf" target="_blank" rel="noopener noreferrer" className={contactLinkClass} data-id="element-112" data-mp="1vs5manuhny3v">
          <DownloadIcon aria-hidden="true" className="h-4 w-4 shrink-0" strokeWidth={2} data-id="element-113" data-mp="25k1oob3lyadw" />
          Download Resume
        </a>
        <a href="mailto:mike@meikson.com" className={contactLinkClass} data-id="element-114" data-mp="1d1e5x2c337fz">
          <MailIcon aria-hidden="true" className="h-4 w-4 shrink-0" strokeWidth={2} data-id="element-115" data-mp="1czkyvlxk6l7g" />
          mike@meikson.com
        </a>
      </nav>
    </Tag>;
}